export default __webpack_public_path__ + "static/media/open_arrow.ac1b30a4.svg";